{
  "name": "@didrod2539/croniq",
  "version": "0.2.0",
  "publishConfig": {
    "access": "public"
  },
  "description": "Tiny, zero-dependency cron toolkit: parse cron expressions, compute next/previous run times (field-jumping, fast), validate, and describe them in plain English. Works in Node, Deno, Bun and the browser.",
  "type": "module",
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "files": [
    "dist"
  ],
  "sideEffects": false,
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "build": "tsup",
    "test": "vitest run",
    "test:watch": "vitest",
    "coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit",
    "lint": "tsc --noEmit",
    "prepublishOnly": "npm run build"
  },
  "keywords": [
    "cron",
    "crontab",
    "cron-parser",
    "schedule",
    "scheduler",
    "cron-expression",
    "next-run",
    "cron-validate",
    "cron-description",
    "interval",
    "zero-dependency",
    "cli"
  ],
  "author": "didrod205 (https://github.com/didrod205)",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/didrod205/croniq.git"
  },
  "bugs": {
    "url": "https://github.com/didrod205/croniq/issues"
  },
  "homepage": "https://github.com/didrod205/croniq#readme",
  "devDependencies": {
    "@types/node": "^22.19.19",
    "@vitest/coverage-v8": "^2.1.8",
    "tsup": "^8.3.5",
    "typescript": "^5.7.2",
    "vitest": "^2.1.8"
  },
  "bin": {
    "croniq": "./dist/cli.js"
  }
}
